import React from 'react';

const AwardAsCmHeader = () => {
    return(
        <>
            <section class="intro-about section-margin" style={{marginBottom: '0px'}}>
                    <div class="container" style={{paddingBottom: '50px'}}>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="intro-content-text" style={{paddingTop: '90px'}}>

                                    <h2 data-dsn-grid="move-section" data-dsn-move="-30" data-dsn-duration="100%"
                                        data-dsn-opacity="1.2" data-dsn-responsive="tablet" style={{color:'#000', textAlign: 'center'}}>
                                        Award - Pawan Chamling
                                    </h2>

                                    <p class="economy-page-header-desc" style={{maxWidth:'100%', color:'#000', textAlign: 'center', paddingLeft: '80px', paddingRight: '80px'}}>
                                    Pawan Chamling has been the recipient of several awards nationally and internationally for his contributions in a vast number of fields from the field of agriculture, environment, education to literature and culture.
                                    </p>


                                </div>
                            </div>

                        </div>
                    </div>

                </section>
        </>
    );
};

export default AwardAsCmHeader;